module.exports = __webpack_public_path__ + "img/output-onlinepngtools.95c20871.png";